export default [
  {
    code: 'international-exemption-application',
    value: 'International exemption application',
    selected: false
  },
  {
    code: 'an end-of-life event',
    value: 'an end-of-life event',
    selected: false
  },
  {
    code: 'funeral',
    value: 'going to a funeral',
    selected: false
  },
  {
    code: 'returning-home',
    value: 'returning home for health, wellbeing, care or compassionate reasons',
    selected: false
  },
  {
    code: 'emergency-relocation',
    value: 'emergency relocation',
    selected: false
  },
  // {
  //   code: 'have-not-been-in-red-zone',
  //   value:
  //     "I am returning home and haven't been in the Greater Sydney area (excluding the Blue Mountains) and Central Coast area in the last 14 days, in the Blue Mountains or Wollongong areas after 11.59pm on 26 December 2020, or any other part of NSW or a red zone in Queensland after 11.59pm on 1 January 2021.",
  //   selected: false
  // },
  {
    code: 'caring-for-animal',
    value: 'caring for an animal on the other side of the border',
    selected: false
  },
  {
    code: 'boarding-school',
    value: 'transport to and from boarding school',
    selected: false
  }
  // Removed as per CBP-214
  // {
  //   code: 'adf-military-transfer',
  //   value: 'Australian Defence Force members undertaking military transfers',
  //   selected: false
  // },
  // Removed as per CBP-455
  // {
  //   code: 'other',
  //   value: 'other reason (these are rare and only granted in limited circumstances).',
  //   selected: false
  // }
];
